import { NextPage } from 'next';
import { GetStaticProps, GetStaticPaths } from 'next';
import Audioknigi from '@/components/screens/audioknigi/Audioknigi';
import useRedirectToFirstPage from '@/hooks/useRedirectToFirstPage';
import { BOOKS_FOR_PAGE, PRERENDER_PAGES, API_URL, REVALIDATE_TIME } from '@/helpers/variables';
import { getPagesNumbersPaths } from '@/helpers/helpers';
import { IBooksPage } from '@/interfaces/booksPage.interface';

const NewPageDynamic: NextPage<IBooksPage> = ({ books }) => {
  useRedirectToFirstPage('/audioknigi/sorting/rating/');
  return <Audioknigi books={books} sortingName="по рейтингу" sortingUrl={'sorting/rating'} />;
};

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = getPagesNumbersPaths(PRERENDER_PAGES);
  return {
    paths,
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async (context) => {
  const { pageNumber } = context.params!;

  const res = await fetch(`${API_URL}satellite/books?book_type=audio_book&page=${pageNumber}&page_size=${BOOKS_FOR_PAGE}&sort_field=rating&sort_reversed=true`);
  const books = await res.json();

  return {
    props: { books },
    revalidate: REVALIDATE_TIME,
  };
};

export default NewPageDynamic;
